<fcom-pnr-widget
  *ngIf="initialValues$ | async as initialValues"
  [widgetTitle]="'MMB.labels.manageBooking'"
  [buttonText]="'MMB.login.submitText'"
  [backgroundImage]="backgroundImage"
  [tourOperatorImage]="tourOperatorImage"
  [operator]="operator"
  [translationPrefix]="'MMB.checkIn.loginFields'"
  [loading]="loading"
  [disruptions$]="disruptions$"
  [error$]="mainError$"
  [cmsArticle$]="cmsArticle$"
  [recLocRegex]="recLocRegex"
  [prefilledRecLoc]="initialValues.recLoc"
  [prefilledLastName]="initialValues.lastName"
  (formSubmit)="onSubmit($event)"
  (clearError)="closeErrorNotification()"
  (cancelRetrieve)="cancelRetrieve()"
>
  <ng-container info-links>
    <ng-container *ngIf="!operator">
      <div class="inline-block">
        <a
          data-testid="info-link-recloc"
          class="font-body-1 bold-type nordic-blue-900-text"
          [finLink]="'MMB.links.recloceticket.link.url' | finLocalization"
          [openInNewTab]="true"
          [external]="true"
          (mousedown)="$event.preventDefault()"
          >{{ 'MMB.links.recloceticket.text' | finLocalization }}</a
        >
      </div>
      <div class="inline-block mr-small-t">
        <a
          data-testid="info-link-refund"
          class="font-body-1 bold-type nordic-blue-900-text"
          [finLink]="'MMB.links.refund.link.url' | finLocalization"
          [openInNewTab]="true"
          [external]="true"
          (mousedown)="$event.preventDefault()"
          >{{ 'MMB.links.refund.text' | finLocalization }}</a
        >
      </div>
    </ng-container>
    <ng-container *ngIf="operator && 'MMB.links.' + operator + '.link.url' | finHasLocalizationKey">
      <div class="inline-block">
        <a
          data-testid="operator-link"
          class="inline-block font-body-1 nordic-blue-900-text"
          [finLink]="'MMB.links.' + operator + '.link.url' | finLocalization"
          [openInNewTab]="true"
          [external]="true"
          (mousedown)="$event.preventDefault()"
          >{{ 'MMB.links.' + operator + '.text' | finLocalization }}</a
        >
      </div>
    </ng-container>
  </ng-container>
</fcom-pnr-widget>

<ng-container modal-info>
  <fcom-modal
    *ngIf="groupFirstNameForm"
    data-testid="entry-widget-group-modal"
    [title]="'MMB.login.group.title' | finLocalization"
    [buttons]="ModalButtons.CUSTOM"
    [fitToContent]="true"
    (close)="onFirstNameModalClose()"
    [isOpen]="showGroupBookingModal$ | async"
  >
    <div class="block pr-large">
      <h2 class="nordic-blue-900-text font-heading-3 mr-small-b">
        {{ 'MMB.login.group.heading' | finLocalization }}
      </h2>
      <p class="mr-small-b">
        {{ 'MMB.login.group.info' | finLocalization }}
      </p>

      <form [formGroup]="groupFirstNameForm" (ngSubmit)="submitGroupFirstName()" data-first-name-form>
        <fcom-text-input
          class="flex-1 flex--basis0 ms-large-b"
          [parentForm]="groupFirstNameForm"
          [displayMargin]="false"
          [controlName]="'firstName'"
          [required]="false"
          [translationPrefix]="'MMB.login.group.firstName'"
        ></fcom-text-input>
      </form>

      <fcom-notification
        data-testid="entry-widget-group-modal-error-notification"
        *ngIf="groupModalError$ | async as error"
        [theme]="NotificationTheme.ALERT"
        [layout]="NotificationLayout.BLOCK"
        aria-live="polite"
      >
        {{ 'MMB.login.errors.' + error | finLocalization }}
      </fcom-notification>
    </div>

    <div buttons>
      <fcom-button
        *ngIf="!loading"
        data-testid="entry-widget-group-booking-first-name-submit"
        class="mr-xsmall-r"
        [type]="ButtonType.SUBMIT"
        [disabled]="!groupFirstNameForm.valid"
        [text]="'actions.continue' | finLocalization"
        [aria]="{ label: 'actions.continue' | finLocalization, role: 'button' }"
        (clickBtn)="submitGroupFirstName()"
      ></fcom-button>
      <fcom-loader *ngIf="loading" class="pr-xsmall block" [loaderType]="LoaderTheme.INLINE"> </fcom-loader>
    </div>
  </fcom-modal>
</ng-container>
